import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGuideIcon = props => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="#000" d="M.5 12.5A1.5 1.5 0 0 0 2 14h8a1.5 1.5 0 0 0 1.5-1.5v-10A1.5 1.5 0 0 0 10 1H9a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1h1a.5.5 0 0 1 .5.5v10a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-10A.5.5 0 0 1 2 2h.5V1H2A1.5 1.5 0 0 0 .5 2.5zM4 2V1h4v1z" />;
    t1 = <path fill="#000" d="M2.5 4.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M5 4.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 6.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M5 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 8.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M5 8.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5M2.5 10.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0M5 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5" />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 12 14" {...props}>{t0}{t1}</svg>;
    $[2] = props;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
export default SvgGuideIcon;